import { Injectable } from '@angular/core';
import * as firebase from 'firebase/app';
import { Utils } from './utils';

@Injectable()
export class PlanesProvider {

    planes: Plan[] = [
        { id: '', name: 'PackCode 5', numProyects: 5, price: 14.90 },
        { id: '', name: 'PackCode 15', numProyects: 15, price: 39.90 },
        { id: '', name: 'PackCode 30', numProyects: 30, price: 74.90 },
        { id: '', name: 'PackCode 50', numProyects: 50, price: 119.90 },
    ];

    database: firebase.database.Database = firebase.database();
    ruta: string = 'planes';

    constructor(private _utils: Utils) { }

    all(): Promise<Plan[]> {
        let promise: Promise<Plan[]> = new Promise(resolve => {
            this.database.ref(this.ruta).once('value').then(snap => {
                if (snap.exists()) {
                    let temp: Plan[] = [];
                    snap.forEach((s) => {
                        temp.push(new Plan(s.val()))
                    });
                    resolve(temp);
                } else {
                    resolve([]);
                }
            });
        });
        return promise;
    }

    fakes() {
        this.planes.forEach(plan => {
            this.store(plan);
        });
    }

    find(id: string): Promise<Plan> {
        let promise: Promise<Plan> = new Promise(resolve => {
            this.database.ref(this.ruta).child(id).once('value', snap => {
                resolve(snap.val());
            });
        });
        return promise;
    }

    findByUser(id: string): Promise<PlanHtml> {
        let promise: Promise<PlanHtml> = new Promise(resolve => {
            this.database.ref('usuario_plan').child(id).once('value').then(snap => {
                if (snap.exists()) {
                    let keys = Object.keys(snap.val());
                    resolve(new PlanHtml(snap.val()[keys[0]]));
                } else {
                    resolve(null);
                }
            });
        });
        return promise;
    }

    findByUserQrs(id: string, key?: string): Promise<ProyectQr[]> {
        let promise: Promise<ProyectQr[]> = new Promise(resolve => {
            this.database.ref('usuario_codigos_qr').child(id).once('value').then(snap => {
                if (snap.exists()) {
                    let qrs: ProyectQr[] = [];
                    snap.forEach(s => {
                        if (!key) {
                            qrs.push(new ProyectQr(s.val()));
                        } else {
                            if (key == s.key)
                                qrs.push(new ProyectQr(s.val()));
                        }

                    });
                    resolve(qrs);
                } else {
                    resolve(null);
                }
            });
        });
        return promise;
    }

    findByUserPqr(idUser: string, idPqr: string) {
        let promise: Promise<ProyectQr> = new Promise(resolve => {
            this.database.ref(`usuario_codigos_qr/${idUser}/${idPqr}`).once('value').then(snap => {
                if(snap.exists())
                    resolve(new ProyectQr(snap.val()));
                else
                    resolve(null);
            });
        });
        return promise;
    }

    findRedirectPqr(id: string): Promise<string> {
        let promise: Promise<string> = new Promise(resolve => {
            this.database.ref('redirect_pqr').child(id).once('value').then(snap => {
                if (snap.exists()) {
                    resolve(snap.val());
                } else {
                    resolve(null);
                }
            });
        });
        return promise;
    }

    store(plan: Plan) {
        plan.id = this.database.ref(this.ruta).push().key;
        return this.database.ref(this.ruta).child(plan.id).set(plan);
    }

    storeByUser(id: string, plan: PlanHtml) {
        let promise: Promise<PlanHtml> = new Promise(resolve => {
            plan.id = this.database.ref('usuario_plan').child(id).push().key;
            this.database.ref('usuario_plan').child(id).child(plan.id).set(plan);
            resolve(plan);
        });
        return promise;
    }

    storeQr(id: string, proyectQr: ProyectQr): Promise<ProyectQr> {
        proyectQr.numeroSerie = this._utils.bsin(5);
        let promise: Promise<ProyectQr> = new Promise(resolve => {
            proyectQr.id = this.database.ref('usuario_codigos_qr').child(id).push().key;
            this.database.ref('usuario_codigos_qr').child(id).child(proyectQr.id).set(proyectQr);
            this.database.ref('redirect_pqr').child(proyectQr.numeroSerie).set('dashboard/' + id + '/proyecto/' + proyectQr.id);
            resolve(proyectQr);
        });
        return promise;
    }

    storeRedirectPqr(idUser: string, proyectQr: ProyectQr) {
        return this.database.ref('redirect_pqr').child(proyectQr.numeroSerie).set('dashboard/' + idUser + '/proyecto/' + proyectQr.id);
    }

    update(plan: Plan) {
        return this.database.ref(this.ruta).child(plan.id).set(plan);
    }

    updateQr(idUser: string, pqr: ProyectQr) {
        return this.database.ref('usuario_codigos_qr').child(idUser).child(pqr.id).set(pqr);
    }

    updateQrChild(idUser: string, proyectQrId: string, child: string, value: string) {
        return this.database.ref('usuario_codigos_qr').child(idUser).child(proyectQrId).child(child).set(value);
    }

    updateCarpetaQr(idUser: string, idProyectQr: string, carpeta: {
        index: number;
        name: string;
        pdfs: PdfCarpetaProyectQr[];
    }) {
        let c = {
            name: carpeta.name,
            pdfs: carpeta.pdfs
        }
        return this.database.ref('usuario_codigos_qr').child(idUser).child(idProyectQr + '/carpetas').child(carpeta.index.toString()).set(c);
    }

    uploadFile(file, usuarioId, proyectoId, carpetaId): Promise<PdfCarpetaProyectQr> {
        let promise: Promise<PdfCarpetaProyectQr> = new Promise(resolve => {
            firebase.storage().ref(`usuarios/${usuarioId}/proyectos/${proyectoId}/carpeta/${carpetaId}`).child(file.name).put(file).then(imageStorage => {
                resolve({ name: file.name, file: imageStorage.downloadURL });
            });
        });
        return promise;
    }

    removeFile(file, usuarioId, proyectoId, carpetaId) {
        return firebase.storage().ref(`usuarios/${usuarioId}/proyectos/${proyectoId}/carpeta/${carpetaId}`).child(file.name).delete();
    }
}

export class Plan {
    id: string;
    name: string;
    numProyects: number;
    price: number;
    constructor(plan?: Plan) {
        this.id = (plan) ? plan.id : '';
        this.name = (plan) ? plan.name : '';
        this.numProyects = (plan) ? plan.numProyects : 0;
        this.price = (plan) ? plan.price : 0;
    }
}
export class PlanHtml {
    id: string;
    numProyects: number;
    price: number;
    proyectsQr: ProyectQr[];
    url: string;

    constructor(plan?: PlanHtml) {
        this.id = (plan) ? plan.id : '';
        this.numProyects = (plan) ? plan.numProyects : 0;
        this.price = (plan) ? plan.price : 0;
        this.proyectsQr = (plan) ? plan.proyectsQr : [];
        this.url = (plan) ? plan.url : '';
    }
}

export class ProyectQr {
    carpetas: CarpetaProyectQr[];
    id: string;
    imageQr: string;
    info: string;
    name: string;
    numeroSerie: string;
    pass: string;
    personInfo: string;

    constructor(proyect?: ProyectQr) {
        this.carpetas = (proyect) ? proyect.carpetas : [{ name: 'default', pdfs: [] }];
        this.id = (proyect) ? proyect.id : '';
        this.imageQr = (proyect) ? proyect.imageQr : '';
        this.info = (proyect) ? (proyect.info) ? proyect.info : '' : '';
        this.name = (proyect) ? (proyect.name) ? proyect.name : '' : 'Proyecto Qr';
        this.numeroSerie = (proyect) ? proyect.numeroSerie : '';
        this.pass = (proyect) ? (proyect.pass) ? proyect.pass : '' : '';
        this.personInfo = (proyect) ? (proyect.personInfo) ? proyect.personInfo : '' : '';
    }
}

export class CarpetaProyectQr {
    name: string;
    pdfs: PdfCarpetaProyectQr[];
}

export class PdfCarpetaProyectQr {
    name: string;
    file: any;
}


// WEBPACK FOOTER //
// ./src/app/providers/planes.ts